<template>
	<div>
		<PopulationList
			v-bind:label="label"
			v-bind:url="url"
			@print="setPrint">
		</PopulationList>
		<div class="detail">
			<router-view
				v-bind:label="label"
				v-bind:url="url"
				v-bind:print="print">
			</router-view>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PopulationList from './list/List'

export default {
	name: 'population',

	props: {
		label: {
			type: String
		}
	},

	data() {
		return {
			print: null
		}
	},

	computed: {
		...mapState('provider', [
			'loading',
			'provider'
		]),
		providerLabel() {
			if (this.provider)
				return this.provider.label.find((label) => (label.id == this.label))
			return ''
		},
		url() {
			return (this.label == null) ? '/patient' : ('/label/' + this.label)
		}
	},

	methods: {
		...mapActions('provider', [
			'loadPatients'
		]),
		setPrint(print) {
			this.print = print
		}
	},

	components: {
		PopulationList
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
